var map = {
	"./amor-arm-0.png": "c96e",
	"./amor-arm-1.png": "b1af",
	"./amor-base.png": "a6be",
	"./amor-shadow.png": "f71d",
	"./arrow-0.png": "45f6",
	"./arrow-1.png": "47c9",
	"./arrow-2.png": "dc13",
	"./arrow-3.png": "1a05",
	"./arrow-4.png": "dd48",
	"./arrow.png": "c5d4",
	"./no-target.png": "a575",
	"./target-0.png": "3079",
	"./target-1.png": "3ab7",
	"./target-2.png": "7860",
	"./target-3.png": "3b18",
	"./target-4.png": "e7b5",
	"./target-5.png": "eb4d",
	"./title.png": "f773"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";